module.exports = "/_next/static/images/dlya-domu-a0b2ac39a3ec315fa174f6aec6e66d32.svg";